import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import API from "../../services/api";

function AdminChangePassword() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [password, setPassword] = useState("");

  const handleUpdate = async () => {
    await API.put(`/api/admin/users/${id}/password`, {
      newPassword: password
    });

    navigate("/admin/users");
  };

  return (
    <div className="container mt-4">
      <h4>Change User Password</h4>

      <input
        type="password"
        className="form-control mb-3"
        placeholder="New Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />

      <button className="btn btn-success" onClick={handleUpdate}>
        Update Password
      </button>
    </div>
  );
}

export default AdminChangePassword;